import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ApiService} from '../../services/api.service';


@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {
  url: any;

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    public  apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) {
    // console.log(modalData);
  }

  ngOnInit() {
    // this.url=this.modalData.url;
  }

  actionFunction() {
    this.modalData.function();
    // this.closeModal();
  }

  closeModal() {
    this.dialogRef.close();
  }

  onSelectFile(event) {
    const size = event.target.files[0].size;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event) => { // called once readAsDataURL is completed
        this.modalData.url = event.target.result;
        // console.log(this.modalData.url);

      };
    }
  }
}
